module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }]
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('h4', {
    staticStyle: {
      "color": "#0f673b",
      "padding-top": "20px"
    }
  }, [_vm._v("\n                    เพิ่มข้อมูลเห็ด\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "form-style-5"
  }, [_c('form', {
    attrs: {
      "method": "post",
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('input', {
    ref: "mushroom_thai",
    attrs: {
      "type": "text",
      "placeholder": "ชื่อเห็ดไทย"
    }
  }), _vm._v(" "), _c('input', {
    ref: "mushroom_science",
    attrs: {
      "type": "text",
      "placeholder": "ชื่อวิทยาศาสตร์"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "mushroom_type"
    }
  }, [_vm._v("ประเภทเห็ด:")]), _vm._v(" "), _c('select', {
    ref: "mushroom_type",
    attrs: {
      "id": "mushroom_type"
    }
  }, [_c('option', {
    attrs: {
      "value": "unknown"
    }
  }, [_vm._v("ไม่ทราบ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "poison"
    }
  }, [_vm._v("เห็ดพิษ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "edible"
    }
  }, [_vm._v("เห็ดกินได้")])])]), _vm._v(" "), _c('fieldset', [_vm._m(1), _vm._v(" "), _c('input', {
    ref: "mushroom_location",
    attrs: {
      "type": "text",
      "placeholder": "สถานที่เก็บ"
    }
  }), _vm._v(" "), _c('input', {
    ref: "mushroom_source_data",
    attrs: {
      "type": "text",
      "placeholder": "แหล่งข้อมูล"
    }
  }), _vm._v(" "), _c('input', {
    ref: "mushroom_note",
    attrs: {
      "type": "text",
      "placeholder": "อื่นๆ"
    }
  })]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "_csrf_token",
      "id": "_csrf_token"
    },
    domProps: {
      "value": _vm.getAuthen.token
    }
  }), _vm._v(" "), _c('fieldset', [_vm._m(2), _vm._v(" "), (_vm.isInitial || _vm.isSaving) ? _c('div', {
    staticClass: "dropbox"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "multiple": "multiple",
      "name": _vm.uploadFieldName,
      "disabled": _vm.isSaving,
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files);
        _vm.fileCount = $event.target.files.length
      }
    }
  }), _vm._v(" "), (_vm.isInitial) ? _c('p', [_vm._v("\n                                    คลิก!! ที่นี่เพื่ออัพโหลดภาพ"), _c('br'), _vm._v(" "), _vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', [_vm._v("\n                                    Uploading " + _vm._s(_vm.fileCount) + " files..."), _c('br'), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../assets/loading.gif"),
      "width": "32"
    }
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSuccess || _vm.countFilesUpload != 0) ? _c('div', [(_vm.countFilesUpload) ? _c('h2', [_vm._v("Uploaded " + _vm._s(_vm.countFilesUpload) + " file(s) successfully.")]) : _vm._e(), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_c('icon', {
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "name": "remove"
    }
  }), _vm._v("  ลบภาพทั้งหมด")], 1), _vm._v("\n                                     || \n                                     "), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.addImage()
      }
    }
  }, [_c('icon', {
    staticStyle: {
      "color": "green"
    },
    attrs: {
      "name": "plus"
    }
  }), _vm._v(" เพิ่มภาพ")], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "list-inline"
  }, _vm._l((_vm.uploadedFiles), function(item) {
    return _c('li', [_c('img', {
      staticClass: "img-responsive img-thumbnail",
      attrs: {
        "src": item.url,
        "alt": item.originalName
      }
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.isFailed) ? _c('div', [_c('h2', [_vm._v("Uploaded failed.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("Try again")])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.uploadError))])]) : _vm._e()]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "บันทึก"
    },
    on: {
      "click": _vm.submitButtionClick
    }
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', {
    staticClass: "legend-left"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("1")]), _vm._v(" ข้อมูลเห็ด")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', {
    staticClass: "legend-left"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("2")]), _vm._v(" สถานที่เก็บหรือแหล่งข้อมูล")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('legend', {
    staticClass: "legend-left"
  }, [_c('span', {
    staticClass: "number"
  }, [_vm._v("3")]), _vm._v(" ภาพเห็ด")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "color": "tomato"
    }
  }, [_vm._v(" ชื่อภาพต้องเป็นภาษาอังกฤษหรือตัวเลขเท่านั้น "), _c('br'), _vm._v("ถ้าเป็นภาษาไทยจะมีปัญหาในการอัพโหลด")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3eec816c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddMushRoom.vue
// module id = 1087
// module chunks = 1